import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppSettings } from "../app-settings";

import { Storage } from "@ionic/storage";
import { AccountService } from "./account.service";
@Injectable({
  providedIn: "root",
})
export class InventoryService {
  /*
  /api/inventory/
  /api/inventory/import/
 */

  constructor(
    private http: HttpClient,
    private storage: Storage,
    private accountService: AccountService
  ) {}
  public get(inventoryItemId) {
    let promise = new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        this.http
          .get(AppSettings.SERVER_URL + `inventory/${inventoryItemId}/`, {
            headers: headers,
          })
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });
    return promise;
  }
  public list(page = 1, filters = {}, sort = []) {
    let promise = new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        let params = new HttpParams().append("page", page.toString());

        if (!!filters) {
          Object.keys(filters).forEach((key) => {
            params = params.append(key, filters[key]);
          });
        }
        if (sort.length > 0) {
          params = params.append("sort", JSON.stringify(sort));
        }
        this.http
          .get(AppSettings.SERVER_URL + "inventory/", {
            params: params,
            headers: headers,
          })
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });

    return promise;
  }
  public import(fileToUpload: File) {
    let promise = new Promise(async (resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        let endpoint = AppSettings.SERVER_URL + "inventory/import/";
        let formData: FormData = new FormData();
        formData.append("file", fileToUpload, fileToUpload.name);
        this.http
          .post(endpoint, formData, options)
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((e) => reject(e));
      });
    });
    return promise;
  }
  public purge() {
    let promise = new Promise(async (resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        let endpoint = AppSettings.SERVER_URL + "inventory/purge/";
        this.http
          .get(endpoint, options)
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((e) => reject(e));
      });
    });
    return promise;
  }

  public uploadFileInfos(form) {
    let promise = new Promise((resolve, reject) => {
      this.storage.get("session").then((session) => {
        let key = session["key"];

        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        let url = AppSettings.SERVER_URL + "inventory/import_url/";

        this.http
          .post(url, form, options)
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((e) => reject(e));
      });
    });
    return promise;
  }

  public getFileInfos() {
    let promise = new Promise((resolve, reject) => {
      this.storage.get("session").then((session) => {
        let key = session["key"];

        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        let url = AppSettings.SERVER_URL + "inventory/import_url/";

        this.http
          .get(url, options)
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });
    return promise;
  }

  public deleteUpload() {
    let promise = new Promise((resolve, reject) => {
      this.storage.get("session").then((session) => {
        let key = session["key"];

        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        const options = { headers: headers };

        let url = AppSettings.SERVER_URL + "inventory/import_url/";

        this.http
          .delete(url, options)
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });
    return promise;
  }
}
